export default __webpack_public_path__ + "static/media/pacnckagebackgroundlight.dfe7ca5b.png";